import { InvocaPhoneNumber } from "@src/common/InvocaPhoneNumber";
import { LAYOUT_CONSTANTS } from "@src/constants";
import { isUnder18AgeRange } from "@src/utils/scheduling-metadata";
import { styled } from "@uhg-abyss/web/tools/styled";
import { Checkbox } from "@uhg-abyss/web/ui/Checkbox";
import { Fragment } from "react";

const FormFooterContainer = styled("div", {
  width: "100%",
  fontSize: "14px",
  textAlign: "left",
  maxWidth: LAYOUT_CONSTANTS.maxFormWidth,
  marginTop: "20px",
  padding: "0 8px",
  backgroundColor: "transparent",
  variants: {
    isMobile: {
      true: {
        marginTop: "0",
        padding: "0 20px 24px",
        backgroundColor: "$app.color.surface.container.secondary",
      },
    },
  },
});

export const FormFooter = ({ isChecked, setIsChecked, showError, isMobile, ageRange }) => {
  const hasError = showError && !isChecked;
  const isMinor = ageRange ? isUnder18AgeRange(ageRange) : undefined;

  const getFooterLabel = () => {
    if (isMinor === true) {
      return (
        <Fragment>
          I understand that I'm scheduling this visit for a minor for whom I am a legal guardian or
          otherwise legally authorized personal representative. For other scheduling needs,
          including scheduling an appointment for a minor for whom I am not a legal guardian or
          otherwise legally authorized representative, I need to call{" "}
          <strong>
            <InvocaPhoneNumber />
          </strong>
          .
        </Fragment>
      );
    }

    if (isMinor === false) {
      return (
        <Fragment>
          I understand that I'm scheduling this visit for myself or on behalf of another adult.
        </Fragment>
      );
    }

    return (
      <Fragment>
        I understand that I'm scheduling this visit for myself or on behalf of another adult.
      </Fragment>
    );
  };

  return (
    <FormFooterContainer isMobile={isMobile}>
      <Checkbox
        data-testid="test-id-get-started-consent-checkbox"
        label={getFooterLabel() as unknown as string}
        isChecked={isChecked}
        id="obc-get-started-form-footer-checkbox"
        data-obc-label="Get Started Form Footer Checkbox"
        onChange={(e) => {
          return setIsChecked(e.target.checked);
        }}
        css={
          hasError
            ? {
                "abyss-checkbox-label": {
                  color: "$app.color.text.status.error",
                },
                borderColor: "$app.color.text.status.error",
                color: "$app.color.text.status.error",
                borderWidth: "2px",
              }
            : {
                "abyss-checkbox-label": {
                  color: "$app.color.text.secondary",
                },
                color: "$app.color.text.secondary",
                borderWidth: "2px",
              }
        }
      />
    </FormFooterContainer>
  );
};
